export default __webpack_public_path__ + "static/media/fizen.edea1113.png";